import { QueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

// Default QueryClient — feature query hooks live in
// `src/features/<feature>/api.ts` per ADR-0005 §3. Query-key convention:
//   ['<feature>', ...filters]  /  ['<entity>', id]
//
// Retries:
//  - 4xx never retries — these are deterministic (validation, auth, 403). The
//    response interceptor in `src/api/client.ts` already handles 401 via
//    silent refresh + retry-once before the rejection ever reaches Query.
//  - 5xx retries once.
//
// staleTime of 30s balances freshness against the BR-A04 sub-5s budget for
// the future results dashboard.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const status = toStatus(error);
        if (status !== null && status >= 400 && status < 500) {
          return false;
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: {
      retry: false,
    },
  },
});

function toStatus(error: unknown): number | null {
  const status = (error as AxiosError | undefined)?.response?.status;
  return typeof status === 'number' ? status : null;
}
